import React from 'react';

function LandingTileGrid({ children, className = '' }) {
  return <div className={`row landing-card-grid ${className}`.trim()}>{children}</div>;
}

export default LandingTileGrid;
